export const UPDATE_MERCHANT_DEFAULT_PAYMENT_METHOD = `mutation UpdateMerchantDefaultPaymentMethod($input: MerchantUpdateMutationInput!) {
  merchantUpdate(input: $input) {
    merchant {
      defaultPaymentMethod {
        id
      }
    }
  }
}`;
